/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

import * as Sentry from '@sentry/browser';

if (process.env.MIX_APP_ENV === 'production') {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
        environment: process.env.MIX_APP_ENV,
        serverName: process.env.MIX_APP_URL,
    })
    if (document.querySelector('meta[name="user-email"]')) {
        Sentry.configureScope(function (scope) {
            scope.setUser({
                email: document.querySelector('meta[name="user-email"]').content
            });
        });
    }
}

require('./components/gallery')
require('./components/galleryUpload')
require('./components/datapickers')
require('./components/phoneNumbers')
require('./components/ProgressViewer');
require('./components/UploadFields');
require('./components/ProgressImageCompare');
require('./components/youtube');
